import React, { useEffect, useState, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import SliderPage from "../WhatWeDo/components/SliderPage.js";
import digitalService from "../../Images/Digital-transformation-services1.jpg";
import Digital from "../../Images/Digital-transformation-services.svg";
import { ReactComponent as Bulb } from "../../Images/bulb.svg";
import { ReactComponent as Efficient } from "../../Images/efficient.svg";
import { ReactComponent as Person } from "../../Images/person.svg";
import { ReactComponent as Insights } from "../../Images/dataInsight.svg";
import { ReactComponent as Trophy } from "../../Images/trophy.svg";
import ContactUs from "../Contact/ContactUs";
import Footer from "../Footer/Footer";
import DetailsCard, {
  ThreeColumnContainer,
} from "../WhatWeDo/components/DetailsCard";
import cardData from "../../resources/cardData.json";
import imageHeader from "../../resources/imageHeader.json";
import SubHeadings from "../WhatWeDo/components/SubHeadings.js";
import ImageHeader from "../WhatWeDo/components/ImageHeader.js";
import { useNavigate } from "react-router-dom";

import RealEstateTechstack from "../Techstack/RealEstateTechstack.js";
import logoTextData from "../../resources/logoTextData.json";
import IconCard from "../WhatWeDo/components/IconCard";
import { ReactComponent as Code } from "feather-icons/dist/icons/code.svg";
import { ReactComponent as Database } from "feather-icons/dist/icons/database.svg";
import { ReactComponent as Location } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as Dollar } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Message } from "feather-icons/dist/icons/message-square.svg";
import { ReactComponent as Key } from "feather-icons/dist/icons/key.svg";
import WhoWeAre from "../WhoWeAre/WhoWeAre";
import { ContactUsPDF } from "./CommonPages/ContactUsPDF.js";
import TeckStackPDF from "./CommonPages/TeckStackPDF.js";
import WhoWeArePDF from "./CommonPages/WhoWeArePDF.js";
import Slider from "../WhatWeDo/components/Slider.js";
const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const LogoContainer = tw.div`flex lg:justify-end absolute mb-10 z-1 w-full`;
const LogoText = tw.h5`ml-0 text-6xl pt-5 text-white font-bold `;
const Description = tw.p`px-6 font-semibold py-5 my-10 text-sm md:text-xl text-gray-900 text-center`;
const TwoCol = styled.div`
  ${tw`flex justify-between max-w-screen-xl mx-auto`}
`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto mt-8   `;

let data = [
  {
    imageSrc: <Bulb />,
  },
  {
    imageSrc: <Efficient />,
  },
  {
    imageSrc: <Person />,
  },
  {
    imageSrc: <Trophy />,
  },
  {
    imageSrc: <Insights />,
  },
];
const keyBenefits = cardData.digital.keyBenefits.map((item, index) => (
  <DetailsCard
    key={index}
    title={item.point}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));
const imgStyle = { width: "40px", height: "40px" };
let integrationData = [
  {
    imageSrc: <Location style={imgStyle} />,
  },
  {
    imageSrc: <Database style={imgStyle} />,
  },
  {
    imageSrc: <Code style={imgStyle} />,
  },
  {
    imageSrc: <Dollar style={imgStyle} />,
  },
  {
    imageSrc: <Message style={imgStyle} />,
  },
  {
    imageSrc: <Key style={imgStyle} />,
  },
];

const integrationSpecialities =
  logoTextData.thirdpartyintegrations.integrationspecialities.map(
    (item, index) => (
      <IconCard
        readmore={true}
        key={index}
        title={item.title}
        url={item.url}
        description={item.description}
        imageSrc={integrationData[index].imageSrc}
      />
    )
  );

const DigitalTransformationPDF = () => {
  let [current, setCurrent] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let slidesData = [
    {
      image: digitalService,
      typeID: "element5",
      typedHead:
        "Leverage new technologies from maps, messaging and other online tools to enhance your business.",
      heading1: "Digital ",
      heading2: "transformation services",
      route: "/what-we-do/digital-transformation-services",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    document.title = "Welcome to Iqura - Digital Transformation Services";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Iquras experts offer a wide variety of Digital Transformation services to enhance your processes and facilitate growth and scalability"
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      " Seamless digital interactions, Digital Transformation Services | Strategy, Solutions and Consulting"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href =
      "https://www.iqura.tech/what-we-do/digital-transformation-services";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setTimeout(() => {
      setAnimate(false);
    }, 1400);
  }, []);

  return (
    <div className="overflow-hidden relative ">
          <div style={{visibility:"hidden",position:"absolute" , top: "-9999px"}}>
  <Slider/>
 </div>
 <div className="" style={{ height: "100vh" }}>
      <div className="overflow-hidden relative  ">
        <LogoContainer>
          <div className="flex lg:justify-end w-full mr-16  ">
            <LogoText className="logoFontFamily">Iqura</LogoText>
          </div>
        </LogoContainer>
        <div
          className="flex transition-transform ease-out duration-300 "
          style={{
            transform: `translateX(-${current * 100}%)`,
          }}
        >
          {slides.map((s) => {
            return (
              <div className="z-22" style={{ width: "100%" }}>
                {s}
              </div>
            );
          })}
        </div>

        <div className="absolute bottom-0 py-4 flex justify-center gap-3 w-full   ">
          {slides.map((s, i) => {
            return (
              <div
                onClick={() => {
                  setCurrent(i);
                }}
              ></div>
            );
          })}
        </div>
      </div>
  
        <TwoCol>
          <WrapperDescription>
            <Description
              style={{
                backgroundColor: "white",
                marginTop: `${window.innerWidth <= 425 ? -140 : -35}px`,
                padding: "40px",
                   transform:"scale(1.25)"
              }}
            >
              <ImageHeader
                imageHeaderData={imageHeader.Digital}
                imgsource={Digital}
              />
            </Description>
          </WrapperDescription>
        </TwoCol>
        </div>
        <div>
      <WhoWeArePDF/>
          <div
        div className ="  flex justify-center items-center  "style={{ height: "100vh" }}
          >
            <div className="px-20 "  style={{ transform:"scale(1.35)",paddingBottom:"120px" }} >
              <div id="benefits" className="div-class"></div>
              <SubHeadings heading1="Key" heading2="benefits" />
              <ThreeColumnContainer>{keyBenefits}</ThreeColumnContainer>
            </div>
          </div>
          <div
        div className ="  flex justify-center items-center  "style={{ height: "100vh" }}
          >
              <div className="px-20 "  style={{ transform:"scale(1.35)" }} >
              <div id="integrations" className="div-class">
                <SubHeadings heading1="Third Party" heading2="Integrations" />
                {/* <DescriptionContainer data={cardData.Digital.howItWorks} /> */}
                <ThreeColumnContainer>
                  <Description>
                    Our capabilities and experience with third-party systems and
                    APIs will help you maximize your workflows with efficient
                    and seamless integrations with your existing systems.
                  </Description>
                </ThreeColumnContainer>
                <ThreeColumnContainer>
                  {integrationSpecialities}
                </ThreeColumnContainer>
              </div>
            </div>
          </div>
        <TeckStackPDF/>
<ContactUsPDF/>
        
        </div>

    </div>
  );
};

export default DigitalTransformationPDF;
